import React, { useState } from "react";
import "./ResultOpenHour.scss";
import ReactTable from "../../Table";
import CandleGraphs from "../../../reusableComponents/CandleGraphs/CandleGraphs";
import { FormatUSD } from "../../../utils/helpers/string";

const ResultOpenHour = ({result_by_open_hour }) => {

  const performance_trade = {
    name:"Profit",
    data:
      result_by_open_hour?.account_data_analysis?.result_by_open_hour
        ?.chart_data?.average_profit_loss ?? [],
    time:
      result_by_open_hour?.account_data_analysis?.result_by_open_hour
        ?.chart_data?.duration ?? [],
  };

  const [params, setParams] = useState({
    page: 1,
    page_size: 9,
    active: null,
    platform: null,
  });
  const handleChange = (selectedOption) => {
    setParams((pre) => ({ ...pre, active: selectedOption.value }));
  };

  const columns = [
    {
      Header: () => (
        <div className="header-with-icon">
          <span>Day</span>
        </div>
      ),
      accessor: "Duration",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value}</p>
        </div>
      ),
    },
    {
      Header: () => (
        <div className="header-with-icon">
          <span>No. Of Trades</span>
        </div>
      ),
      accessor: "no_of_trade",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p>{value}</p>
        </div>
      ),
    },
    {
      Header: () => (
        <div className="header-with-icon">
          <span>Results</span>
        </div>
      ),
      accessor: "results",
      Cell: ({ value }) => (
        <div className="col-wrapper">
          <p
            className={
              value > 0 ? "positive_value" : value < 0 ? "negative_value" : ""
            }
          >
            {FormatUSD(value)}
          </p>
        </div>
      ),
    },
  ];

  return (
    <div className="resultOpenHourMain">
      <div className="profit-by-open-hour">
        <div className="trade-reports">
          <div className="header_Wrapper">
            <h2 className="component-heading">Average PnL in Open Hour</h2>
          </div>
          <div className="chart-box-wrapper">
            <div className="tabs-wrapper tabs-1">
              <div className="chart-box">
                <CandleGraphs
                  data={performance_trade}
                  dataSymbol="amount"
                  title="Time"
                  graphType="Profit"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="open-hour-table">
        <ReactTable
          columns={columns}
          data={
            result_by_open_hour?.account_data_analysis?.result_by_open_hour
              ?.data
          }
          variant={2}
        />
      </div>
    </div>
  );
};

export default ResultOpenHour;
